// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1HDx6","log":"ModalInventoryLogs_log__2oUDS","date":"ModalInventoryLogs_date__jQ7vV","userName":"ModalInventoryLogs_userName__3iLb0"};